import React, { Dispatch, SetStateAction, useState } from 'react';
import { useSelector } from 'react-redux';

import DataTableHeader from 'components/common/table/datatable/DataTableHeader';
import NewDataTableBody from 'components/common/table/datatable/NewDataTableBody';
import { selectComment } from 'features/member/reducer/memberDetailSlice';
import { selectCommentListLoading } from 'features/member/reducer/backorderSlice';

import { getCommentTableColumn } from './column';

import CommentModals from './commentModals/CommentModals';
import { DEFAULT_COMMENT_INFO } from '../constants';

import { UpdateCommentItemType } from './column';
import { Comment } from 'types/member';

interface Props {
  userId: string;
  currentPage: number;
  selectedModalType: UpdateCommentItemType;
  setSelectedModalType: Dispatch<SetStateAction<UpdateCommentItemType>>;
}

const CommentTableList = ({
  userId,
  currentPage,
  selectedModalType,
  setSelectedModalType,
}: Props) => {
  const { items: commentList, totalItems } = useSelector(selectComment);
  const commentListLoading = useSelector(selectCommentListLoading);

  const [selectedComment, setSelectedComment] = useState<Comment>(DEFAULT_COMMENT_INFO);

  const commentTableColumnData = getCommentTableColumn({
    currentPage,
    totalItems,
    onItemClick: ({ comment, type }) => {
      setSelectedComment(comment);
      setSelectedModalType(type);
    },
  });

  return (
    <>
      <CommentModals
        userId={userId}
        selectedComment={selectedComment}
        selectedModalType={selectedModalType}
        onModalClose={() => {
          setSelectedComment(DEFAULT_COMMENT_INFO);
          setSelectedModalType(undefined);
        }}
      />

      <DataTableHeader header={commentTableColumnData} />
      <NewDataTableBody<Comment>
        dataList={commentList as Comment[]}
        columns={commentTableColumnData}
        loading={commentListLoading}
      />
    </>
  );
};

export default CommentTableList;
